module.exports = __webpack_public_path__ + "img/Setaria_viridis.125d5389.jpg";